// i18n.js
// Requires: npm install react-i18next i18next@23 i18next-http-backend@2 i18next-browser-languagedetector@7 --legacy-peer-deps
//
// Language resolution priority:
//   1. Customer.languageId from DB → resolved in AuthContext → i18n.changeLanguage(code)
//   2. localStorage('haytour_lang') → persists last-used language across page refreshes
//   3. Browser navigator language → best-effort fallback for guests
//   4. 'en' → hardcoded fallback when nothing else matches or language has no translation file

import i18n              from 'i18next';
import { initReactI18next }         from 'react-i18next';
import HttpBackend                  from 'i18next-http-backend';
import LanguageDetector             from 'i18next-browser-languagedetector';

i18n
    .use(HttpBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'en',

        // Only these three have real translation files.
        // Every other DB language code (hy, fr, de, ar, ja, …) will fall back to EN.
        supportedLngs: ['en', 'ru', 'es'],

        // When a user has e.g. languageId pointing to Armenian (hy),
        // i18next will try /locales/hy/translation.json, fail to load it,
        // then automatically serve the EN fallback. No crash, no empty strings.
        nonExplicitSupportedLngs: true,

        detection: {
            order:              ['localStorage', 'navigator'],
            caches:             ['localStorage'],
            lookupLocalStorage: 'haytour_lang',
        },

        backend: {
            // CRA serves /public as static root; Vite does the same
            loadPath: '/locales/{{lng}}/translation.json',
        },

        interpolation: {
            escapeValue: false,
        },

        react: {
            useSuspense: false,
        },
    });

export default i18n;